import React from 'react';
import { musicNoteIcon } from '@chordbaker/design';

interface MusicNoteIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const MusicNoteIcon: React.FC<MusicNoteIconProps> = ({
  className,
  size = 12,
  color = 'currentColor'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={musicNoteIcon.viewBox}
      fill={color}
      className={className}
    >
      <path d={(musicNoteIcon.elements[0] as { d: string }).d} />
    </svg>
  );
};

export default MusicNoteIcon;
